import {
  Box,
  Flex,
  Text,
  IconButton,
  Stack,
  Collapse,
  Icon,
  Link,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useDisclosure,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  AbsoluteCenter,
} from "@chakra-ui/react";
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
//import { NavLink as ReachLink } from "react-router-dom";
import { HashLink as ReachHashLink } from "react-router-hash-link"; // sorts out problem with navliink
import { useLocation } from "react-router-dom";
import Logo from "../../static/CUC_LOGO_NEW_MIN.svg";
import { LoginMenu } from "./LoginMenu/LoginMenu";
import React, { useState } from "react";
import { UserMenu } from "./UserMenu/UserMenu";
import "./style.css";
import { useAuth } from "../../auth/useAuth";
import { useNavigate } from "react-router-dom";
import FacebookLogo from "../../images/footer/facebook.svg";
import InstagramLogo from "../../images/footer/instagram.svg";
import WhatsappLogo from "../../images/footer/whatsapp.svg";
import FlagEs from "../../images/flags/flag-es.svg";
import FlagCa from "../../images/flags/flag-ca.svg";
import FlagUk from "../../images/flags/flag-uk.svg";
import { FaArrowLeft } from "react-icons/fa6";
import Cookies from "js-cookie";
import { MdOutlineLocalFireDepartment } from "react-icons/md";
import { useTranslation } from "react-i18next";

export function Navbar({ isOpaque }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [opaque, setOpaque] = useState(true);
  const opaqueMandatory = isOpaque == null ? false : isOpaque;
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const currentLanguage = (i18n.language || "es").split("-")[0];
  const languageLabelMap = {
    es: "ES",
    ca: "CA",
    en: "EN",
  };
  const currentLanguageLabel =
    languageLabelMap[currentLanguage] || languageLabelMap.es;
  const languageFlagMap = {
    es: FlagEs,
    ca: FlagCa,
    en: FlagUk,
  };
  const currentLanguageFlag =
    languageFlagMap[currentLanguage] || languageFlagMap.es;

  function handleLogout() {
    auth.logout();
    if (Cookies.get("AppView")) {
      navigate("/login");
    } else {
      navigate("/");
    }
  }

  function goBack() {
    if (location.pathname !== "/") {
      navigate("/");
    } else {
      navigate("bonos");
    }
  }

  // Efecto navbar transparente
  onscroll = (event) => {
    window.scrollY > 85 ? setOpaque(false) : setOpaque(true);
  };

  function onCloseDelay() {
    onClose();
  }

  function handleLanguageChange(language) {
    i18n.changeLanguage(language);
  }

  const DesktopNav = ({ onAction }) => {
    const linkColor = "gray.200";
    const linkHoverColor = "white";
    const popoverContentBgColor = "white";

    return (
      <Stack direction={"row"} spacing={4} pt={1} px={0}>
        {NAV_ITEMS.map(
          (navItem) =>
            (navItem.loggedMenu === auth.isLogged() || !auth.isLogged()) && (
              <Box key={navItem.id}>
                <Popover
                  trigger={"hover"}
                  placement={"bottom-start"}
                  bgColor="black"
                >
                  <PopoverTrigger>
                    <Text
                      p={2}
                      as={ReachHashLink}
                      to={navItem.href}
                      fontSize={"md"}
                      fontWeight={500}
                      color={linkColor}
                      _hover={{
                        textDecoration: "none",
                        color: linkHoverColor,
                      }}
                    >
                      {navItem.label}
                    </Text>
                  </PopoverTrigger>

                  {navItem.children && (
                    <PopoverContent
                      boxShadow={"xl"}
                      bg={popoverContentBgColor}
                      p={4}
                      rounded={"md"}
                      minW={"sm"}
                      textAlign="left"
                    >
                      <Stack textAlign={"center"}>
                        {navItem.children.map((child) => (
                          <DesktopSubNav key={child.label} {...child} />
                        ))}
                      </Stack>
                    </PopoverContent>
                  )}
                </Popover>
              </Box>
            )
        )}
      </Stack>
    );
  };

  const DesktopSubNav = ({ label, href, subLabel }: NavItem) => {
    return (
      <Link
        bgColor="white"
        color="white"
        as={ReachHashLink}
        to={href}
        role={"group"}
        display={"block"}
        rounded={"sm"}
        p={0.5}
      >
        <Stack direction={"row"} bgColor="white">
          <Box color="gray.800" align={"flex-start"}>
            <Text
              transition={"all 0.3s ease"}
              _groupHover={{ color: "blue.500" }} /* on click subnav */
              fontWeight={500}
            >
              {label}
            </Text>
            <Text fontSize={"sm"}>{subLabel}</Text>
          </Box>
          <Flex
            transition={"all .3s ease"} /* transición cajita y azul */
            transform={"translateX(-10px)"}
            opacity={0}
            _groupHover={{ opacity: "100%", transform: "translateX(0)" }}
            justify={"flex-end"}
            align={"left"}
            flex={1}
          >
            <Icon color={"blue.500"} w={5} h={5} as={ChevronRightIcon} />
          </Flex>
        </Stack>
      </Link>
    );
  };

  const MobileNav = ({ onAction }) => {
    return (
      <Stack className="fade-in" fontFamily="Oswald">
        {NAV_ITEMS.map(
          (navItem) =>
            (navItem.loggedMenu === auth.isLogged() || !auth.isLogged()) && (
              <MobileNavItem
                onAction={onAction}
                key={navItem.id}
                {...navItem}
              />
            )
        )}
      </Stack>
    );
  };

  const MobileNavItem = ({ id, label, children, href }: NavItem) => {
    const { isOpen, onToggle } = useDisclosure();

    function clicked(e) {
      onCloseDelay();
    }

    return (
      <Stack spacing={2} ml={-2} onClick={children && onToggle}>
        <Link
          py={0.5}
          as={ReachHashLink}
          to={href ?? "#"}
          justify={"space-between"}
          align={"center"}
          _hover={{
            textDecoration: "none",
          }}
          onClick={clicked}
        >
          <Text
            fontWeight={300}
            color="white"
            fontSize={"4xl"}
            textAlign="center"
            id={id}
          >
            {label}
          </Text>
          {children && (
            <Icon
              as={ChevronDownIcon}
              transition={"all 0.3s ease-in-out"} /* Transición icono submenú */
              transform={isOpen ? "rotate(180deg)" : ""}
              w={6}
              h={6}
            />
          )}
        </Link>

        <Collapse in={isOpen} mb={5}>
          <Stack
            mb={4}
            borderLeft={1}
            borderStyle={"solid"}
            borderColor="gray.800"
            align={"start"}
          >
            {children &&
              children.map((child) => (
                <Link
                  key={child.label}
                  py={0}
                  as={ReachHashLink}
                  to={child.href}
                  color="gray.800"
                >
                  {child.label}
                </Link>
              ))}
          </Stack>
        </Collapse>
      </Stack>
    );
  };

  interface NavItem {
    id: string;
    label: string;
    subLabel?: string;
    children?: Array<NavItem>;
    href?: string;
  }

  const NAV_ITEMS: Array<NavItem> = [
    {
      id: "home",
      label: t("navbar.items.home"),
      href: "/#",
      loggedMenu: true,
    },
    {
      id: "services",
      label: t("navbar.items.services"),
      href: "/#services",
      loggedMenu: false,
    },
    {
      id: "schedule",
      label: t("navbar.items.schedule"),
      href: "/#schedule",
      loggedMenu: true,
    },
    {
      id: "rates",
      label: t("navbar.items.rates"),
      href: "/#bonos",
      loggedMenu: true,
    },
    {
      id: "social",
      label: t("navbar.items.social"),
      href: "/#social",
      loggedMenu: false,
    },
    {
      id: "team",
      label: t("navbar.items.team"),
      href: "/#team",
      loggedMenu: false,
    },
    {
      id: "faqs",
      label: t("navbar.items.faqs"),
      href: "/#faqs",
      loggedMenu: false,
    },
  ];

  return (
    <Box>
      <Flex
        position={"fixed"}
        width={"100%"}
        backgroundColor={
          opaqueMandatory || !opaque || isOpen ? "gray.900" : "transparent"
        }
        style={{ transition: "background-color 0.2s ease-in-out" }}
        color="white"
        minH={"80px"}
        py={{ base: 3 }}
        px={{ base: 6 }}
        align={"center"}        
        zIndex={11}
        justifyContent="space-between"
      >
        {/* === SECCIÓN IZQUIERDA === */}
        <Flex 
          align="center" 
          zIndex={12}
        >
          <IconButton
            onClick={auth.isLogged() ? goBack : onOpen}
            color="white"
            display={auth.isLogged() ? "flex" : { base: "flex", md: "none" }}
            icon={
              auth.isLogged() ? (
                location.pathname !== "/" ? (
                  <FaArrowLeft size="1.25em" />
                ) : (
                  <MdOutlineLocalFireDepartment size="1.5em" />
                )
              ) : (
                !isOpen && <HamburgerIcon w={5} h={5} />
              )
            }
            backgroundColor="transparent"
            _hover={{ backgroundColor: "transparent" }}
            aria-label={t("navbar.toggleAria")}
          />

          {/* Logo alineado a la izquierda: Solo Escritorio No Logueado */}
          {!auth.isLogged() && (
            <Box display={{ base: "none", md: "block" }} mr={4}>
              <Link as={ReachHashLink} to={"/"}>
                <img src={Logo} width="48px" height="48px" alt="CUC logo" />
              </Link>
            </Box>
          )}

          {/* Menú al lado del logo: Solo Escritorio No Logueado */}
          {!auth.isLogged() && (
            <Box display={{ base: "none", md: "flex" }}>
              <DesktopNav />
            </Box>
          )}
        </Flex>

        {/* === SECCIÓN CENTRO (ABSOLUTO) === */}
        {/* Se activa siempre en Mobile, y en Desktop solo si está Logueado */}
        {(auth.isLogged() || true) && (
          <Box
            position="absolute"
            left="50%"
            top="50%"
            transform="translate(-50%, -50%)"
            display={auth.isLogged() ? "block" : { base: "block", md: "none" }}
            zIndex={10}
          >
            <Link as={ReachHashLink} to={"/"}>
              <img src={Logo} width="48px" height="48px" alt="CUC logo" />
            </Link>
          </Box>
        )}

        {/* === SECCIÓN DERECHA === */}
        <Stack
          direction={"row"}
          spacing={3}
          align="center"
          zIndex={12}
        >
          <Box display={{ base: "none", md: "block" }} pt={1}>
            <Menu placement="bottom-end">
              <MenuButton
                as={Button}
                rounded={"full"}
                variant={"link"}
                cursor={"pointer"}
                style={{ textDecoration: "none" }}
                minW={0}
              >
                <HStack spacing={1.5}>
                  <Avatar
                    border="2px solid white"
                    size="sm"
                    src={currentLanguageFlag}
                    name={currentLanguageLabel}
                    bg="whiteAlpha.200"
                  />
                  <ChevronDownIcon color="white" mt={0.5} />
                </HStack>
              </MenuButton>
              
              <MenuList borderRadius={0} color="black" maxW="120px" minW="120px">
                <MenuItem onClick={() => handleLanguageChange("es")}>
                  {t("navbar.language.es")}
                </MenuItem>
                <MenuItem onClick={() => handleLanguageChange("ca")}>
                  {t("navbar.language.ca")}
                </MenuItem>
                <MenuItem onClick={() => handleLanguageChange("en")}>
                  {t("navbar.language.en")}
                </MenuItem>
              </MenuList>
            </Menu>
          </Box>
          
          {auth.isLogged() ? (
            <UserMenu onAction={handleLogout} user={auth.user} />
          ) : (
            <LoginMenu />
          )}
        </Stack>
      </Flex>

      <Drawer
        placement={"left"}
        onClose={onClose}
        isOpen={isOpen}
        size="full"
        autoFocus={false}
        returnFocusOnClose={false}
      >
        <DrawerOverlay />

        <DrawerContent
          color="white"
          bgColor="gray.900"
          fontWeight={200}
        >
          <DrawerHeader bgColor="gray.900">
            <HStack h="48px" mr="40px">
              <IconButton
                backgroundColor="transparent"
                _hover={{ backgroundColor: "transparent" }}
                onClick={onClose}
                color="white"
              >
                <CloseIcon w={3} h={3} />
              </IconButton>
              <Flex
                flex={{ base: 1 }}
                justify={{ base: "center", md: "start" }}
                className="oswald-font"
              >
                <Link as={ReachHashLink} to="/" onClick={onCloseDelay}>
                  <img src={Logo} width="48px" height="48px" alt="CUC logo" />
                </Link>
              </Flex>
            </HStack>
          </DrawerHeader>
          <DrawerBody m="auto" /*ml={{base: "30px", sm:"90px", md: "200px"}}*/>
            <AbsoluteCenter>
              <MobileNav onAction={onCloseDelay} />
              <HStack pt={8} spacing={7}>
                <a href="https://wa.me/34674088825">
                  <img src={WhatsappLogo} width="40px" alt="Whatsapp logo" />
                </a>
                <a href="https://www.facebook.com/cucfitness/">
                  <img src={FacebookLogo} width="40px" alt="Facebook logo" />
                </a>
                <a href="https://www.instagram.com/cucfitness/">
                  <img src={InstagramLogo} width="40px" alt="Instagram logo" />
                </a>
                <Menu placement="bottom-end">
                  <MenuButton
                    as={Button}
                    rounded={"full"}
                    variant={"link"}
                    cursor={"pointer"}
                    style={{ textDecoration: "none" }}
                    minW={0}
                    onClick={(event) => event.stopPropagation()}
                  >
                    <HStack spacing={1.5}>
                      <Avatar
                        border="2px solid white"
                        size="sm"
                        src={currentLanguageFlag}
                        name={currentLanguageLabel}
                        bg="whiteAlpha.200"
                      />
                      <ChevronDownIcon color="white" mt={0.5} />
                    </HStack>
                  </MenuButton>
                  <MenuList borderRadius={0} color="black" maxW="120px" minW="120px">
                    <MenuItem
                      fontSize="md"
                      fontWeight="normal"
                      onClick={() => {
                        handleLanguageChange("es");
                        onCloseDelay();
                      }}
                    >
                      {t("navbar.language.es")}
                    </MenuItem>
                    <MenuItem
                      fontSize="md"
                      fontWeight="normal"
                      onClick={() => {
                        handleLanguageChange("ca");
                        onCloseDelay();
                      }}
                    >
                      {t("navbar.language.ca")}
                    </MenuItem>
                    <MenuItem
                      fontSize="md"
                      fontWeight="normal"
                      onClick={() => {
                        handleLanguageChange("en");
                        onCloseDelay();
                      }}
                    >
                      {t("navbar.language.en")}
                    </MenuItem>
                  </MenuList>
                </Menu>
              </HStack>
            </AbsoluteCenter>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
}